// Styles
import '@/assets/styles/app.scss';

// Polyfills
import 'es6-promise/auto';

// Libraries
import Vue from 'vue';
import Vuelidate from 'vuelidate';
import Vuex from 'vuex';
import moment from 'moment';

// i18n
import '@/i18n';

// Plugins
import HttpError from './plugins/http-error';
import Logger from './plugins/logger';
import Kendo from './plugins/kendo';
import GlobalId from './plugins/globalid';
import DashboardPDK from 'dashboard-pdk';
import PDK from 'pdk';

// Global Assets
import './components/globals';
import './directives/globals';

//Kendo UI license
import "@progress/kendo-ui";
import "../kendo-ui-license.js";

// Services
import { account, groups, http as httpService, users } from '@/services';

// Startup
import App from './app';
import AppConfig from './config';
import router from '@/router';
import store, { getters, actions, mutations } from '@/store';

// Disable moment's deprecation warnings
moment.suppressDeprecationWarnings = AppConfig.env.production || AppConfig.env.testing;

// Vue Configurations
Vue.use(Vuelidate);
Vue.use(Vuex);
Vue.use(Kendo);
Vue.use(HttpError);
Vue.use(Logger);
Vue.use(GlobalId);
Vue.use(PDK, {
    appConfig: AppConfig,
    services: {
        http: httpService
    }
});
Vue.use(DashboardPDK, {
    appConfig: AppConfig,
    services: {
        http: httpService,
        account,
        groups,
        users
    },
    store,
    storeTypes: {
        getters,
        actions,
        mutations
    },
    widgets: []
});

Vue.config.productionTip = false;

// Don't spin up the app if we are testing - we don't need it
if (!AppConfig.env.testing) {
    /* eslint-disable no-new */
    Vue.$auth
        .init({ onLoad: 'login-required', checkLoginIframe: false })
        .then(() => {
            new Vue({
                el: '#app',
                store,
                router,
                components: { App },
                template: '<app />'
            });

            // Refresh the token when users return focus to the tab.
            window.onfocus = () => {
                Vue.$auth.updateToken(AppConfig.auth.refreshThreshold);
            };
        });
}
